import { useEffect, useState } from "react";
import { Phone, MessageSquare } from "lucide-react";

const STAGES = [
  { key:"new",         label:"New",         color:"#64748b" },
  { key:"contacted",   label:"Contacted",   color:"#2563eb" },
  { key:"qualified",   label:"Qualified",   color:"#7c3aed" },
  { key:"proposal",    label:"Proposal",    color:"#ca8a04" },
  { key:"negotiation", label:"Negotiation", color:"#ea580c" },
  { key:"won",         label:"Won",         color:"#16a34a" },
  { key:"lost",        label:"Lost",        color:"#dc2626" },
];

function getToken() { return localStorage.getItem("token"); }

export default function Pipeline() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/leads", {
      headers: { Authorization: `Bearer ${getToken()}` },
    })
      .then(res => res.json())
      .then(data => {
        setLeads(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const moveStage = async (lead, newStage) => {
    // Optimistically update UI
    setLeads(prev => prev.map(l => l.id === lead.id ? { ...l, stage: newStage } : l));

    try {
      await fetch(`/api/leads/${lead.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({ ...lead, stage: newStage }),
      });
    } catch {
      // Revert on failure
      setLeads(prev => prev.map(l => l.id === lead.id ? lead : l));
    }
  };

  return (
    <div className="page">
      <div className="page-header">
        <div className="page-title">Sales Pipeline</div>
      </div>
      {loading ? (
        <p style={{ color:"#94a3b8" }}>Loading...</p>
      ) : (
        <div className="pipeline-board">
          {STAGES.map(stage => {
            const stageLeads = leads.filter(l => l.stage === stage.key);
            const total = stageLeads.reduce((s, l) => s + (l.value || 0), 0);
            return (
              <div key={stage.key} className="pipeline-col">
                <div className="pipeline-col-header">
                  <div className="pipeline-col-dot" style={{ background: stage.color }} />
                  <span className="pipeline-col-label">{stage.label}</span>
                  <span className="pipeline-col-count">{stageLeads.length}</span>
                </div>
                {total > 0 && <div className="pipeline-total">${total.toLocaleString()}</div>}
                {stageLeads.map(lead => (
                  <div key={lead.id} className="pipeline-card">
                    <div className="pipeline-card-name">{lead.name}</div>
                    {lead.company && <div className="pipeline-card-sub">{lead.company}</div>}
                    {lead.value > 0 && <div className="pipeline-card-value">${lead.value.toLocaleString()}</div>}
                    <div style={{ display:"flex", gap:6, marginTop:6 }}>
                      {lead.phone && <Phone size={12} color="#94a3b8" />}
                      {lead.whatsapp_chat_id && <MessageSquare size={12} color="#94a3b8" />}
                    </div>
                    <div className="pipeline-card-move">
                      {STAGES.filter(s => s.key !== stage.key).map(s => (
                        <button key={s.key} className="pipeline-move-btn" onClick={() => moveStage(lead, s.key)}>
                          → {s.label}
                        </button>
                      ))}
                    </div>
                  </div>
                ))}
                {stageLeads.length === 0 && <div className="pipeline-empty">No leads</div>}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}